import { render } from "./WeaponDetail.vue?vue&type=template&id=42c82ada&scoped=true"
import script from "./WeaponDetail.vue?vue&type=script&lang=js"
export * from "./WeaponDetail.vue?vue&type=script&lang=js"

import "./WeaponDetail.vue?vue&type=style&index=0&id=42c82ada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c82ada"]])

export default __exports__